// Les rares textes que les composants nova affichent eux-mêmes (le libellé caché du bouton
// de fermeture). La bibliothèque ne connaît pas la langue : l'application les fournit,
// traduits, une fois à la racine. Avant le 06/10 ce libellé était « Fermer » pour tous.
import * as React from "react"

export type TextosUI = { cerrar: string }

const Contexto = React.createContext<TextosUI>({ cerrar: "" })

export function TextosUIProvider({ value, children }: { value: TextosUI; children: React.ReactNode }) {
  return <Contexto.Provider value={value}>{children}</Contexto.Provider>
}

export function useTextosUI() {
  return React.useContext(Contexto)
}
